import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import './NewCard.scss';
import Textarea from '../Textarea';

export default class NewCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { selected: false };
  }

  componentDidMount() {
    if (this.inputField) {
      this.inputField.focus();
    }
  }

  handleValueChanged(e){
    if(e.target.value.trim() !== '' || !e.target.value){
      this.setState({ name: e.target.value });
    }
  }

  handleClick(e){
    const { handleNewCardSelected } = this.props;
    if (handleNewCardSelected){
      handleNewCardSelected(this.props.selected ? false : true);
    }
  }

  handleCreateBuild(){
    const { handleCreate, parent } = this.props;
    if (this.state.name) {
      if (handleCreate && parent) {
        handleCreate(this.state.name, parent);
      }
      this.setState({ name: '' });
    }
  }

  handleCreateTask(){
    const { handleCreate, parent } = this.props;
    if (this.state.name) {
      if (handleCreate && parent) {
        handleCreate(this.state.name, parent);
      }
      this.setState({ name: '' });
    }
  }

  handleClearBuild(){
    this.setState({ name: '' });
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      if (this.props.type == 'task') {
        this.handleCreateTask();
      }
      else {
        this.handleCreateBuild();
      }
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClearBuild();
    }
  }

  handleClearTask(){
    this.setState({ name: '' });
  }

  render() {
    const { type } = this.props;
    let name, addAction, clearAction, connector;

    if (type == 'build'){
      name = this.textMap.build;
      addAction = this.handleCreateBuild;
      clearAction = this.handleClearBuild;
      connector = <hr className={this.props.connectorClass}/>;
    }
    else if (type == 'task'){
      name = this.textMap.task;      
      addAction = this.handleCreateTask;
      clearAction = this.handleClearBuild;
    }

    return (
      <div id={this.props.id} onClick={this.handleClick} className={'new-task-card-container' + (type == 'task' ? ' new-task-card-container--task' : '')}  >
        {connector}
        <Textarea className={'text-area-' + type} placeholder={'Create New ' + name} onChange={this.handleValueChanged}
          value={this.state.name ? this.state.name : ''} onKeyDown={this.handleKeyDown} ref={element => {this.inputField = element;}}/>
        <hr className={'separator-' + type}/>
        <div className='action-buttons'>
          <div className={'add-button-' + type + (!this.state.name ? ' disabled' : '')} onClick={addAction}>{this.textMap.add.toUpperCase()}</div>
          <div className={'cancel-button-' + type} onClick={clearAction}>{this.textMap.cancel.toUpperCase()}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewCard/index.js